import React, { SVGProps } from 'react';
import logo_small from "../images/logo_small.png";

const Logo = (props: SVGProps<SVGSVGElement>) => (
    <img src={logo_small} className="main-logo"/>
);

export default Logo;
